var rich_content_viewer_default = {
  "fontElementMap": "Ti4Pj",
  "wrapper": "VimZk",
  "pluginContainerMobile": "-coGO",
  "viewer": "WUJgh",
  "android": "cMl0V",
  "rootedTraversedContent": "sAMzG",
  "atomic": "UVjzT",
  "toolbar": "QqT2m",
  "block": "URpvG"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
